

import { form19DataInfoType } from '@/types/Information/Form19';
import { partiesDataJsonDataType } from '@/types/Information/json';
import { Component, Vue } from 'vue-property-decorator';

import { namespace } from "vuex-class";
import "@/store/modules/information";
const informationState = namespace("Information");

import "@/store/modules/forms/form19";
const form19State = namespace("Form19");

@Component
export default class Form19StyleOfProceeding extends Vue {

    @informationState.State
    public partiesJson: partiesDataJsonDataType;

    @informationState.State
    public fileNumber: string;

    @form19State.State
    public form19Info: form19DataInfoType;

    @form19State.Action
    public UpdateForm19Info!: (newForm19Info: form19DataInfoType) => void  
    
    @form19State.State
    public currentNoticeOfWithdrawalOfLawyerId: string;

    @form19State.Action
    public UpdateCurrentNoticeOfWithdrawalOfLawyerId!: (newCurrentNoticeOfWithdrawalOfLawyerId: string) => void
    
    dataReady = false;
    applicantNames: string[] = [];
    respondentNames: string[] = [];
    partyNames: string[] = [];
    lawyerNameOptions: string[] = [];
    showNoneBcAlert=false

    state = {
        firstAppellant: null,
        firstRespondent: null,        
        withdrawingLawyerName: null, 
        withdrawingLawyerNameOther: null, 
        representingParties: null,
        phoneNumbers: null,       
        addresses: null,  
        authorizedName:null,
        email: null,
        nonBcAddress: null
    }

    mounted() {
        this.dataReady = false;
        this.extractInfo();             
    }

    public extractInfo(){     

        if(this.currentNoticeOfWithdrawalOfLawyerId){
            this.getForm19Data();
           
        } else {  
            const form19Data = {} as form19DataInfoType;                  

            form19Data.appellants = this.partiesJson.appellants
            form19Data.respondents = this.partiesJson.respondents;
            form19Data.formSevenNumber = this.fileNumber;
            form19Data.version = this.$store.state.Application.version; 
            form19Data.representingParties = [];
                  
            this.UpdateForm19Info(form19Data);            
            this.saveForm(true);                  
            
        }       

    }

    public extractPartiesData(){

        this.applicantNames = [];
        this.respondentNames = [];
        this.partyNames = [];
        this.lawyerNameOptions = [];        

        for (const applicant of this.form19Info.appellants){
            this.applicantNames.push(applicant.name);
            this.partyNames.push(applicant.name)  
            if (applicant.solicitor){
                
                const lawyerName = 
                    Vue.filter('getFullName')(applicant.solicitor.counselFirstName, applicant.solicitor.counselLastName)+
                    (applicant.solicitor.firmName? " ("+applicant.solicitor.firmName+")":"");

                if (!this.lawyerNameOptions.includes(lawyerName)){
                    this.lawyerNameOptions.push(lawyerName);
                }
            }         
        }

        for (const respondent of this.form19Info.respondents){
            this.respondentNames.push(respondent.name);
            this.partyNames.push(respondent.name);
            if (respondent.solicitor){
                
                const lawyerName = 
                    Vue.filter('getFullName')(respondent.solicitor.counselFirstName, respondent.solicitor.counselLastName)+
                    (respondent.solicitor.firmName? " ("+respondent.solicitor.firmName+")":"");
                
                if (!this.lawyerNameOptions.includes(lawyerName)){
                    this.lawyerNameOptions.push(lawyerName);
                }
                
            }
        }
        
        this.lawyerNameOptions.push('Other')
        this.dataReady = true;

    }  

    public getForm19Data() {        
       
        this.$http.get('/form19/forms/'+this.currentNoticeOfWithdrawalOfLawyerId)
        .then((response) => {
            if(response?.data?.data){            
                            
                const form19Data = response.data.data                
                this.UpdateForm19Info(form19Data) 
                this.extractPartiesData();
                this.clearStates();                
            }
                
        },(err) => {
            console.log(err)        
        });      
    }   

    public clearStates(){
        this.state = {
            firstAppellant: null,
            firstRespondent: null,        
            withdrawingLawyerName: null, 
            withdrawingLawyerNameOther: null, 
            representingParties: null,
            phoneNumbers: null,           
            addresses: null, 
            authorizedName:null,
            email: null,
            nonBcAddress: null
        }
        this.dataReady = true; 
    }

    public recheckStates(){
        
        this.state.nonBcAddress = this.verifyAddresses().nonBC;

        for(const field of Object.keys(this.state)){
            if(this.state[field]==false){
                this.checkStates()
                return 
            }
        }
    }

    public checkStates(){        
        
        this.state.firstAppellant = !this.form19Info.firstAppellant? false : null;
        this.state.firstRespondent = !this.form19Info.firstRespondent? false : null;

        this.state.withdrawingLawyerName = !this.form19Info.withdrawingLawyerName? false : null; 
        if (this.form19Info.withdrawingLawyerName == 'Other'){
            this.state.withdrawingLawyerNameOther = !this.form19Info.withdrawingLawyerNameOther? false : null; 
        } else {
            this.state.withdrawingLawyerNameOther = null;
        }

        this.state.representingParties = (this.form19Info.representingParties.length == 0)? false : null; 
        
        this.state.phoneNumbers = !this.verifyPhoneNumbers()? false : null;
        
        const verifiedAddresses = this.verifyAddresses()
        this.state.addresses = verifiedAddresses.valid;
        this.state.nonBcAddress = verifiedAddresses.nonBC;

        this.state.email = !this.verifyEmails()? false : null;
           
        this.state.authorizedName = !this.form19Info.authorizedName? false : null;       
        
        for(const field of Object.keys(this.state)){
            if(this.state[field]==false){
                Vue.filter('findInvalidFields')()
                return false
            }
        }
        return true            
    } 
    
    public verifyPhoneNumbers(){
        const phoneNumbers = this.form19Info.phoneNumbers? this.form19Info.phoneNumbers.split(','): [''];
        for(const phoneNumber of phoneNumbers){            
            if(!Vue.filter('verifyPhone')(phoneNumber))            
                return false;
        }
        return true;
    }

    public verifyEmails(){
        const emails = this.form19Info.emailAdresses? this.form19Info.emailAdresses.split(','):[''];
        for(const email of emails){
            if(email && !Vue.filter('verifyEmail')(email.trim()))
                return false
        }
        return true
    }

    public verifyAddresses(){
        let nonBC = null
        const addresses = this.form19Info.addresses? this.form19Info.addresses.split(';'): [''];
        for(const address of addresses){ 

            const verifiedAddress = Vue.filter('verifyAddress')(address)
            
            if(verifiedAddress=='EMPTY' && (!this.form19Info.emailAdresses || !this.verifyEmails()))                  
                return {valid:false, nonBC:null};
            if(verifiedAddress=='ERR')
                return {valid:false, nonBC:null};
            if(verifiedAddress=='NONE_BC') nonBC = true
        }
        return {valid:null, nonBC:nonBC};
    }

    public saveForm(draft: boolean) { 
        
        let method = 'post';
        let url = '/form19/forms';

        if (this.currentNoticeOfWithdrawalOfLawyerId){
            method = 'put';
            url = '/form19/forms/'+this.currentNoticeOfWithdrawalOfLawyerId;               

            if (!draft && !this.checkStates()){               
                return                
            } 
            
            const options = {
                method: method,
                url: url,                
                data: {
                    data:this.form19Info,
                    type:'Form19',
                    description:'Notice of Withdrawal of Lawyer'
                }
            }
            this.saveInfo(options, draft);

        } else {           

            const options = {
                method: method,
                url: url,
                data: {
                    data:this.form19Info,
                    type:'Form19',
                    description:'Notice of Withdrawal of Lawyer'
                }
            }
            this.saveInfo(options, draft);
        }        
       
    }

    public saveInfo(options, draft){

        this.$http(options)
            .then(response => {
                if(response.data){
                    if(options.method == "post"){
                        this.UpdateCurrentNoticeOfWithdrawalOfLawyerId(response.data.file_id);
                        this.extractPartiesData();                        
                    }

                    this.clearStates();                    
                    if(!draft) this.navigateToPreviewPage();                           
                }
            }, err => {
                const errMsg = err.response.data.error;
                
            })
    }   

    public navigateToPreviewPage() {          
        if (this.checkStates()){
            if(this.state.nonBcAddress)
               this.showNoneBcAlert=true
            else
                this.$router.push({name: "preview-form19"});
        }        
    }

    public confirmNavigateToPreviewPage(){
        this.showNoneBcAlert=false
        this.$router.push({name: "preview-form19"});
    }

}
